import PhoneNumberService from "@/services/PhoneNumberService";
import OTPService from "@/services/OTPService";

export default {
  data() {
    return {
      formData: {
        binance_email: "",
        phone_number: "",
        wallet_address: "",
        phone_otp: "",
        email_otp: "",
        passport_proof: null,
      },
      selectedCountry: "AE",
      nationalPhoneNumber: "",
      countries: [],
      binanceScreenshotFileNames: [], // Add this line
      binanceScreenshotFiles: [], // Add this to store actual files
      isPhoneValid: false,
      phoneInputTouched: false,
      passportFileName: "",

      errors: {},
      isSubmitting: false,
      isPhoneOTPRequested: false,
      isEmailOTPRequested: false,
      phoneOTPButtonText: "Get Code",
      emailOTPButtonText: "Get Code",
      phoneOTPTimer: null,
      emailOTPTimer: null,
      phoneOTPCountdown: 0,
      emailOTPCountdown: 0,
      isPhoneOTPRequesting: false,
      isEmailOTPRequesting: false,
      successMessage: "",
      showSuccessAlert: false,
    };
  },
  created() {
    this.loadCountries();
  },
  methods: {
    handleBinanceScreenshotsUpload(files) {
      // Always append new files
      files.forEach((file) => {
        this.binanceScreenshotFiles.push(file);
        this.binanceScreenshotFileNames.push(file.name);
      });
      this.errors.binance_screenshot = "";
      // Clear any existing errors since user is uploading new files
      this.clearBinanceFileErrors();
    },

    removeBinanceFile(index) {
      this.binanceScreenshotFiles.splice(index, 1);
      this.binanceScreenshotFileNames.splice(index, 1);

      // Clear specific file errors and reindex
      this.clearBinanceFileErrors();
    },
    clearBinanceFileErrors() {
      // Remove all binance_screenshot.* errors
      Object.keys(this.errors).forEach((key) => {
        if (key.startsWith("binance_screenshot.")) {
          delete this.errors[key];
        }
      });

      // Also clear the general binance_screenshot error if no files remain
      if (this.binanceScreenshotFiles.length === 0) {
        delete this.errors.binance_screenshot;
      }

      // Force reactivity update
      this.errors = { ...this.errors };
    },
    loadCountries() {
      this.countries = PhoneNumberService.loadCountries();
    },

    handleCountryChanged(countryCode) {
      this.selectedCountry = countryCode;
      this.updateFullPhoneNumber();
    },

    handlePhoneInput(value) {
      this.nationalPhoneNumber = value;
      this.phoneInputTouched = true;
      this.updateFullPhoneNumber();
    },

    updateFullPhoneNumber() {
      const result = PhoneNumberService.formatPhoneNumber(
        this.nationalPhoneNumber,
        this.selectedCountry
      );
      this.formData.phone_number = result.formattedNumber;
      this.nationalPhoneNumber = result.displayNumber;
      this.isPhoneValid = result.isValid;
    },

    handlePassportUpload(file) {
      this.formData.passport_proof = file;
      this.passportFileName = file.name;
      this.errors.passport_proof = "";
    },

    async requestPhoneOTP() {
      if (
        this.isPhoneOTPRequesting ||
        this.isPhoneOTPRequested ||
        !this.isPhoneValid
      )
        return;

      this.errors.phone_number = "";
      this.isPhoneOTPRequesting = true;
      this.phoneOTPButtonText = "Sending...";

      try {
        const response = await OTPService.requestPhoneOTP(
          this.$store,
          this.formData.phone_number
        );

        if (response && response.status) {
          global.app.$toastr.success("OTP sent to your phone successfully");
          this.startPhoneOTPCountdown();
        } else {
          this.errors.phone_number =
            response?.message || "Failed to send OTP. Please try again.";
          this.phoneOTPButtonText = "Get Code";
        }
      } catch (error) {
        console.error("Phone OTP Error:", error);
        this.errors.phone_number = "An error occurred. Please try again.";
        this.phoneOTPButtonText = "Get Code";
      } finally {
        this.isPhoneOTPRequesting = false;
      }
    },

    startPhoneOTPCountdown() {
      this.phoneOTPCountdown = 60;
      this.phoneOTPButtonText = `Wait ${this.phoneOTPCountdown}s`;
      this.isPhoneOTPRequested = true;

      if (this.phoneOTPTimer) clearInterval(this.phoneOTPTimer);

      this.phoneOTPTimer = setInterval(() => {
        this.phoneOTPCountdown--;
        this.phoneOTPButtonText = `Wait ${this.phoneOTPCountdown}s`;

        if (this.phoneOTPCountdown <= 0) {
          clearInterval(this.phoneOTPTimer);
          this.phoneOTPButtonText = "Get Code";
          this.isPhoneOTPRequested = false;
        }
      }, 1000);
    },

    async requestEmailOTP() {
      if (this.isEmailOTPRequesting || this.isEmailOTPRequested) return;

      this.errors.binance_email = "";
      this.isEmailOTPRequesting = true;
      this.emailOTPButtonText = "Sending...";

      try {
        const response = await OTPService.requestEmailOTP(
          this.$store,
          this.formData.binance_email
        );

        if (response && response.status) {
          global.app.$toastr.success("OTP sent to your email successfully");
          this.startEmailOTPCountdown();
        } else {
          this.errors.binance_email =
            response?.message || "Failed to send OTP. Please try again.";
          this.emailOTPButtonText = "Get Code";
        }
      } catch (error) {
        console.error("Email OTP Error:", error);
        this.errors.binance_email = "An error occurred. Please try again.";
        this.emailOTPButtonText = "Get Code";
      } finally {
        this.isEmailOTPRequesting = false;
      }
    },

    startEmailOTPCountdown() {
      this.emailOTPCountdown = 60;
      this.emailOTPButtonText = `Wait ${this.emailOTPCountdown}s`;
      this.isEmailOTPRequested = true;

      if (this.emailOTPTimer) clearInterval(this.emailOTPTimer);

      this.emailOTPTimer = setInterval(() => {
        this.emailOTPCountdown--;
        this.emailOTPButtonText = `Wait ${this.emailOTPCountdown}s`;

        if (this.emailOTPCountdown <= 0) {
          clearInterval(this.emailOTPTimer);
          this.emailOTPButtonText = "Get Code";
          this.isEmailOTPRequested = false;
        }
      }, 1000);
    },

    validateForm() {
      this.errors = {};
      let isValid = true;

      // Email validation
      if (!this.formData.binance_email) {
        this.errors.binance_email = "Binance email is required";
        isValid = false;
      } else if (
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.binance_email)
      ) {
        this.errors.binance_email = "Please enter a valid email";
        isValid = false;
      }

      // Phone validation
      const phoneValidation = PhoneNumberService.validatePhoneNumber(
        this.formData.phone_number,
        this.selectedCountry
      );

      if (!phoneValidation.isValid) {
        this.errors.phone_number = phoneValidation.error;
        isValid = false;
      } else {
        this.formData.phone_number = phoneValidation.formattedNumber;
      }

      // Other validations
      if (!this.formData.wallet_address) {
        this.errors.wallet_address = "Wallet address is required";
        isValid = false;
      }

      if (!this.formData.phone_otp) {
        this.errors.phone_otp = "Phone OTP is required";
        isValid = false;
      }

      if (!this.formData.email_otp) {
        this.errors.email_otp = "Email OTP is required";
        isValid = false;
      }

      if (!this.formData.passport_proof) {
        this.errors.passport_proof = "Passport proof is required";
        isValid = false;
      }

      if (
        !this.binanceScreenshotFiles ||
        this.binanceScreenshotFiles.length === 0
      ) {
        this.errors.binance_screenshot = "Binance screenshot is required";
        isValid = false;
      }

      if (!this.formData.terms_accepted) {
        this.errors.terms_accepted = "You must accept the terms and conditions";
        isValid = false;
      }

      return isValid;
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      this.errors = {};

      try {
        const formData = new FormData();
        formData.append("binance_email", this.formData.binance_email);
        formData.append("phone_number", this.formData.phone_number);
        formData.append("wallet_address", this.formData.wallet_address);
        formData.append("phone_otp", this.formData.phone_otp);
        formData.append("email_otp", this.formData.email_otp);
        formData.append("passport_proof", this.formData.passport_proof);

        this.binanceScreenshotFiles.forEach((file, index) => {
          formData.append(`binance_screenshot[${index}]`, file);
        });

        const response = await this.$store.dispatch(
          "user/submitAccountVerification",
          formData
        );

        if (response.status) {
          global.app.$toastr.success("Verification submitted successfully");
          this.$router.push("/wallet");
        } else {
          if (response.errors) {
            this.errors = response.errors;
          } else {
            global.app.$toastr.error(
              response.message || "Failed to submit verification"
            );
          }
        }
      } catch (error) {
        console.error("Error submitting verification:", error);
        global.app.$toastr.error(
          "An error occurred while submitting your verification"
        );
      } finally {
        this.isSubmitting = false;
      }
    },

    checkVerificationStatus() {
      if (this.walletData?.user?.verified) {
        this.$router.push("/wallet");
        global.app.$toastr.info("Your account is already verified");
      }
    },
  },
  watch: {
    selectedCountry() {
      this.updateFullPhoneNumber();
    },
    walletData: {
      // eslint-disable-next-line no-unused-vars
      handler: function (newValue) {
        this.checkVerificationStatus();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.checkVerificationStatus();
  },
  beforeDestroy() {
    if (this.phoneOTPTimer) {
      clearInterval(this.phoneOTPTimer);
    }
    if (this.emailOTPTimer) {
      clearInterval(this.emailOTPTimer);
    }
  },
};
